<template>
  <span
    :class="[
      'inline-block whitespace-nowrap align-baseline',
      sizeClass,
      textColorClass,
      bgColorClass,
      borderRadiusClass,
      paddingClass,
      customClass,
      { uppercase: uppercase }
    ]"
    :style="customStyle"
  >
    <slot>{{ text }}</slot>
  </span>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import type { CSSProperties } from 'vue';

  interface Props {
    text?: string;
    textColor?: string;
    bgColor?: string;
    borderRadius?: string;
    padding?: string;
    size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg';
    uppercase?: boolean;
    customClass?: string;
    customStyle?: CSSProperties;
  }

  const props = withDefaults(defineProps<Props>(), {
    text: 'Badge',
    textColor: '',
    bgColor: '',
    borderRadius: 'rounded-full',
    padding: 'p-2',
    size: 'xxs',
    uppercase: true,
    customClass: '',
    customStyle: () => ({})
  });

  const textColorClass = computed(() => {
    return props.textColor.startsWith('#') ? '' : `text-${props.textColor}`;
  });

  const bgColorClass = computed(() => {
    return props.bgColor.startsWith('#')
      ? ''
      : props.bgColor
        ? `bg-${props.bgColor}`
        : '';
  });

  const borderRadiusClass = computed(() => {
    return props.borderRadius;
  });

  const paddingClass = computed(() => {
    return props.padding;
  });

  const sizeClass = computed(() => {
    return `text-${props.size}`;
  });
</script>
